import styled from 'styled-components'
import { ScrollContainerWithHiddenScrollbar } from 'builder/components/ScrollContainer'
import Media from 'builder/styles/media'
import { StepByStepFlow } from '../../StepByStepFlow/StepByStepFlow'

export const Container = styled(ScrollContainerWithHiddenScrollbar)`
  padding-top: 4px;

  ${Media.Tablet`
    overflow-y: visible;
  `}
`

export const StepByStepContainer = styled.div`
  padding-top: 4px;
  display: flex;
  height: 100%;
  flex: auto;
`

export const StyledStepByStepFlow = styled(StepByStepFlow)`
  flex: auto;
  height: unset;
`
